import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

export default function WagonProductList(props) {
  const { products } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      {products?.length > 0 && (
        <TableContainer className={classes.ProductList} component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHead}>
                  {t('Products')}
                </TableCell>
                <TableCell align="left" className={classes.tableHead}>
                  {t('Uncode')}
                </TableCell>
                <TableCell align="left" className={classes.tableHead}>
                  {t('Load limit D')} (t)
                </TableCell>
                <TableCell align="left" className={classes.tableHead}>
                  {t('Load limit C')} (t)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map((row, index) => {
                const key = `row-key-${index}`;
                return (
                  <TableRow key={key}>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      {row.productName ? row.productName : '-'}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {row.unCode ? row.unCode : '-'}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {row.loadLimitD ? row.loadLimitD : '-'}
                    </TableCell>
                    <TableCell align="left" className={classes.tableCell}>
                      {row.loadLimitC ? row.loadLimitC : '-'}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}
